import React from "react";

export default function PageHero({ image, title, subtitle, small = false }) {
  if (!image) {
    return (
      <section className="border-b border-neutral-200 bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-3 text-lg text-[#575757]">{subtitle}</p>}
        </div>
      </section>
    );
  }

  return (
    <section
      className={`relative w-full overflow-hidden bg-[#0c2a66] ${
        small ? "h-[220px] sm:h-[280px]" : "h-[260px] sm:h-[340px] lg:h-[420px]"
      }`}
    >
      <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/45 to-black/65" />
      <div className="relative flex h-full items-center">
        <div className="mr-container-wide text-center">
          <h1 className="font-head mx-auto max-w-4xl text-[24px] font-extrabold leading-tight text-white drop-shadow-[0_2px_10px_rgba(0,0,0,.55)] sm:text-4xl lg:text-[42px]">
            {title}
          </h1>
          {subtitle && (
            <p className="mx-auto mt-4 max-w-2xl text-base font-semibold text-white/90 sm:text-lg">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
